import { useEffect, useState } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    setIsVisible(scrollTop > 200);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      style={{
        zIndex: "999",
      }}
      className={`fixed bottom-36 xl:bottom-3 z-50 right-0   transition-opacity  flex items-center justify-center font-semibold ${
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      } `}
      aria-label="Scroll to top"
    >
      <button
        aria-label="scroll To Top"
        onClick={scrollToTop}
        className=" mt-3 w-14 h-14 flex justify-center items-center rounded-full bg-white text-black hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
      >
        <ArrowUpwardIcon />
      </button>
      
    </div>
  );
};

export default ScrollToTopButton;
